// covered-by: frontends/carrie/src/ask-v2/home/__tests__/AskV2ForYou.test.tsx
import { type GetAskPunttForYouResponse } from "@mg/schemas/src/christo/askPunttOpenItems";

import { API_URL } from "../../config/env";
import { smartFetch } from "../../utils/http";

/** Items waiting on the viewer and their settled requests, across their projects. */
export async function getForYou(): Promise<GetAskPunttForYouResponse> {
  const json = await smartFetch(
    `${API_URL}/private/catalyst/ask-puntt/for-you`,
    { method: "GET" },
  );
  return json as GetAskPunttForYouResponse;
}
